import { render, staticRenderFns } from "./DashBoardResponsibleComponent.vue?vue&type=template&id=4cad8a01&scoped=true&"
import script from "./DashBoardResponsibleComponent.vue?vue&type=script&lang=js&"
export * from "./DashBoardResponsibleComponent.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardResponsibleComponent.vue?vue&type=style&index=0&id=4cad8a01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cad8a01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cad8a01')) {
      api.createRecord('4cad8a01', component.options)
    } else {
      api.reload('4cad8a01', component.options)
    }
    module.hot.accept("./DashBoardResponsibleComponent.vue?vue&type=template&id=4cad8a01&scoped=true&", function () {
      api.rerender('4cad8a01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/components/DashBoardResponsibleComponent.vue"
export default component.exports